"use client";

import PopularRentalCarCard from "./PopularRentalCarCard";
import { useRouter } from "@/i18n/navigation";

export default function HomePopularRentalCarCard({
  item = {},
  onAnalyticsClick,
}) {
  const router = useRouter();

  const mappedCar = {
    ...item,
    CurrencyCode: item?.Currency || item?.CurrencyCode || "TRY",
    Company: {
      Name: item?.CompanyName || item?.Company?.Name || "",
      LogoSlug: item?.Company?.LogoSlug || "",
    },
    CompanyImageUrl: item?.CompanyImageUrl || item?.CompanyImage || "",
    VehicleImages:
      item?.VehicleImages && item.VehicleImages.length > 0
        ? item.VehicleImages
        : item?.ImageUrl
          ? [{ ImageUrl: item.ImageUrl }]
          : [],
  };

  const handleClick = () => {
    onAnalyticsClick?.(item);
    if (item?.RedirectUrl) {
      router.push(item.RedirectUrl);
    }
  };

  return (
    <PopularRentalCarCard
      car={mappedCar}
      handleClick={handleClick}
      index={0}
      useRawSpecLabels
    />
  );
}
